/**
 * Subscription tier metadata. Single source of truth for what each tier
 * costs, what it unlocks, and how it's labeled across the UI.
 */
export const TIERS = {
  free: {
    id: "free",
    label: "Free",
    price: 0,
    priceLabel: "$0",
    concurrent: 1,
    description: "1 active job at a time",
    badge: { bg: "border border-white/10", text: "text-zinc-500" },
  },
  pro: {
    id: "pro",
    label: "Pro",
    price: 59.99,
    priceLabel: "$59.99",
    concurrent: 3,
    description: "3 active jobs at a time",
    badge: { bg: "bg-[#FF9500]", text: "text-white" },
  },
  premium: {
    id: "premium",
    label: "Premium",
    price: 79.99,
    priceLabel: "$79.99",
    concurrent: Infinity,
    description: "Unlimited active jobs",
    badge: { bg: "bg-[#FF3B30]", text: "text-white" },
  },
};

export const tierMeta = (tierId) => TIERS[tierId] || TIERS.free;

export const isPaidTier = (tierId) => tierId === "pro" || tierId === "premium";

export const TRIAL_DAYS = 30;
